<template>
    <div>
        <div class="text-center">
            <p class="text-h4">{{ $t('Congratulations') }}</p>

            <p>{{ $t('Your quest is now active') }}</p>

            <p class="text-h5">{{ $t('Tips') }}</p>
        </div>

        <share-button
            v-if="quest"
            :title="quest.name"
            :description="$options.filters.striphtml(quest.description)"
            :url="shareUrl"
            :email-subject="emailShareSubject"
            :email-body="emailShareBody"
        >
            <template v-slot:activator="{ on }">
                <v-card flat class="bordered-card rounded-lg" @click="on.click">
                    <v-card-text class="d-flex align-center">
                        <v-col class="flex-grow-1 flex-shrink-0 text-h5">
                            {{ $t('Share the quest and invite volunteers') }}
                        </v-col>

                        <v-col class="flex-shrink-1 flex-grow-0 text-right">
                            <v-icon color="primary">fas fa-share-alt</v-icon>
                        </v-col>
                    </v-card-text>
                </v-card>
            </template>
        </share-button>

        <v-card
            :href="feHost + '/plus/quests/'"
            flat
            class="bordered-card rounded-lg mt-2"
            target="_blank"
            v-if="isVisiblePreviewSection"
        >
            <v-card-text class="d-flex align-center">
                <v-col class="flex-grow-1 flex-shrink-0 text-h5">
                    {{ $t('Watch the quest live on the website') }}
                </v-col>

                <v-col class="flex-shrink-1 flex-grow-0 text-right">
                    <v-icon color="primary">fas fa-eye</v-icon>
                </v-col>
            </v-card-text>
        </v-card>

        <v-card
            v-if="quest && quest.pointsApplyStrategy === 'scan'"
            flat
            class="bordered-card rounded-lg mt-2"
            @click="qrCodeModal = true"
        >
            <v-card-text class="d-flex align-center">
                <v-col class="flex-grow-1 flex-shrink-1 text-h5">
                    {{ $t('Lade den QR-Code herunter') }}
                </v-col>

                <v-col class="flex-shrink-1 flex-grow-0 text-right">
                    <v-icon color="primary">fas fa-qrcode</v-icon>
                </v-col>
            </v-card-text>
        </v-card>

        <v-card v-else-if="!isOnlineQuest" flat color="transparent">
            <v-card-text class="d-flex pb-0">
                <v-col class="flex-shrink-1 flex-grow-0">
                    <v-icon color="primary">fas fa-check-circle</v-icon>
                </v-col>
                <v-col class="flex-shrink-0 flex-grow-1">
                    {{ $t('Points will be applied automatically!') }}
                </v-col>
            </v-card-text>
        </v-card>

        <qr-code-overlay v-if="quest && !isOnlineQuest" :quest="quest" v-model="qrCodeModal" />

        <v-card flat color="transparent" v-if="!isOnlineQuest">
            <v-card-text class="d-flex pt-0">
                <v-col class="flex-shrink-1 flex-grow-0">
                    <v-icon color="primary">fas fa-bell</v-icon>
                </v-col>
                <v-col class="flex-shrink-0 flex-grow-1">
                    {{ $t('We will keep you informed e.g. about new volunteers, cancellations and who got points!') }}
                </v-col>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { ActivityModel } from '../../../models';
import ShareButton from '../../ShareButton/ShareButton';
import QrCodeOverlay from '../../QrCodeOverlay';

export default {
    components: {
        ShareButton,
        QrCodeOverlay,
    },
    props: {
        quest: {
            type: Object,
        },
    },
    data() {
        return {
            qrCodeModal: false,
        };
    },
    computed: {
        feHost: () => process.env.VUE_APP_FE_HOST,
        isOnlineQuest() {
            return this.quest.points > 0;
        },
        isVisiblePreviewSection() {
            if (this.quest.activityStatus.name === 'visible_to_all') {
                if (this.isOnlineQuest) {
                    const activityStatus = this.quest.activityStatus.name;
                    const now = new Date();
                    if (activityStatus === 'visible_to_all' && this.quest.startDate.date < now) {
                        return true;
                    }
                    return false;
                }
                return true;
            } else {
                return false;
            }
        },
        emailShareSubject() {
            return ActivityModel.getQuestShareEmailSubject(this, this.quest);
        },
        emailShareBody() {
            return ActivityModel.getQuestShareEmailBody(this, this.quest);
        },
        shareUrl() {
            return ActivityModel.getQuestFEUrl(this.quest);
        },
    },
};
</script>
